export default __webpack_public_path__ + "static/media/img_fee_45.f340f030.svg";